// @flow
import React from 'react'

const Amex = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0-4h32v32H0z" />
        <g fill="#007AC6" fillRule="nonzero">
          <path d="M24.343 9.857l-1.311 1.372-1.223-1.372h-4.018v4.286h3.93l1.311-1.458 1.136 1.457h1.31L23.643 12l1.922-2.143h-1.223zM21.198 13.2H18.75v-.857h2.184v-.857h-2.183v-.772h2.533l1.049 1.2-1.136 1.286zM14.034 12.771l-1.31-2.914h-1.66v4.029l-1.66-4.029H7.919l-1.834 4.286H7.22l.35-.943h2.096l.35.943h2.009V10.8l1.485 3.343h.873L15.87 10.8v3.343h1.048V9.857h-1.66l-1.223 2.915zm-6.115-.514l.7-1.714.699 1.714H7.92z" />
          <path d="M29 .5H3A2.503 2.503 0 0 0 .5 3v18c0 1.378 1.121 2.5 2.5 2.5h26c1.378 0 2.5-1.122 2.5-2.5V3c0-1.379-1.122-2.5-2.5-2.5zM27.138 15h-3.582l-.786-.943-.873.943h-6.989v-.771l-.262.771h-1.747l-.262-.685V15H9.23l-.35-.943h-.873l-.35.943H4.6l2.534-6h2.62l.35.685V9h3.057l.699 1.543L14.559 9h7.6l.786.943.873-.943H27.4l-2.534 3 2.272 3z" />
        </g>
      </g>
    </svg>
  )
}

export default Amex



// WEBPACK FOOTER //
// ./src/components/Icons/Amex.js